import { t } from 'i18next';
import React from 'react'
import {
	FacebookShareButton,
	TwitterShareButton,
	WhatsappShareButton,
} from "react-share";
import {
	FacebookIcon,
	TwitterIcon,
	WhatsappIcon,
} from "react-share";
import style from '../../pages/Blogs/Blogs.module.css'

export default function ShareModal() {
  return (
    <div>
    <div className="modal-header border-bottom-0">
        <h5 className="modal-title " id="locationModalLabel">{t('share')}</h5>
        <button type="button" className="btn-close m-0" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div className="modal-body">
        <div className={`d-flex justify-content-center align-items-center ${style.network__share}`}>
            <FacebookShareButton
                url={window.location.href}
                quote={"Share"}
                hashtag={"#hashtag"}
                description={"facebook"}
                className="network__share-button mx-2"
            >
                <FacebookIcon size={42} round bgStyle={{ fill: 'var(--main-color)' }} />
            </FacebookShareButton>
    
            <TwitterShareButton
                url={window.location.href}
                quote={"Share"}
                hashtag={"#facebook"}
                description={"twitter"}
                className="network__share-button mx-2"
            >
                <TwitterIcon size={42} round bgStyle={{ fill: 'var(--main-color)' }} />
            </TwitterShareButton>
    
            <WhatsappShareButton
                url={window.location.href}
                quote={"Share"}
                hashtag={"#whatsapp"}
                description={"whatsapp"}
                className="network__share-button mx-2"
            >
                <WhatsappIcon size={42} round bgStyle={{ fill: 'var(--main-color)' }} />
            </WhatsappShareButton>
        </div>
    </div>
</div>
  )
}
